module.exports = __webpack_public_path__ + "img/frozen_sweet_corn.e1423446.jpg";